import './App.css';
import Time from './Time';

function App() {
  return (
    <div className="App">
      <Time />
    </div>
  );
}

export default App;
